import React from 'react';

import './styles.scss';

import useUserStore from "../../../data/User.store";
import UsersInfoForm from "../Users.info.form/Users.info.form";
import UserApi from "../../../api/User/User.api";


function UsersAcceptInvitation() {
    const {user, setUser} = useUserStore();

    async function onSubmit(values:any){

        let ret = {...values, company_id: user?.company?.id, user_id:user.id};
        let updatedUser = await UserApi.acceptInvitation(ret);
        if (updatedUser){
            setUser(updatedUser);
        }
    }


    if (!user) {
        return (
            <div className='default-loader-full'>
                <div>Loading user...</div>
            </div>
        )
    }

    return (
        <div className='accept-invitation-form'>
            <div className='accept-invitation-form-content'>
                <div className='accept-invitation-form-content-header'>
                    <div className='title'>
                        Welcome, {user.first_name} {user.last_name}!
                    </div>
                    <div className='description'>
                        Your information has been pre-filled by a FAMR representative. Before you can continue using the FAMR portal, please confirm and/or change any of the following information.
                    </div>
                </div>
                <UsersInfoForm user={user} onSubmit={onSubmit} asAcceptInvitation/>
            </div>
        </div>
    );
}

export default UsersAcceptInvitation;